/**
 * OUTFIT — Service AWIN
 * Publisher ID : 2854419
 * Token : e9e5ea56-9720-442b-89d8-5dede999bcc7
 */

// ⚠️ v1.12.606 — AWIN_TOKEN exposé publiquement dans le bundle JS (à migrer
// vers Lambda proxy en V5.7). En attendant : skip les appels directs depuis
// le navigateur (CORS bloqué par api.awin.com qui ne renvoie pas Access-Control-Allow-Origin).
const AWIN_PUB   = '2854419';
const AWIN_TOKEN = 'e9e5ea56-9720-442b-89d8-5dede999bcc7';
const AWIN_BASE  = 'https://api.awin.com';

// Détection web : Platform.OS === 'web' (RN-Web). Sur mobile natif, pas de CORS.
let IS_WEB = false;
try {
  const { Platform } = require('react-native');
  IS_WEB = Platform.OS === 'web';
} catch {}

export const AWIN_ADVERTISER_IDS = {
  zalando: '7476',
  asos:    '11949',
  zara:    '18532',
  rakuten: '55615', // Rakuten FR (mode H/F)
};

function authHeaders() {
  return {
    'Authorization': 'Bearer ' + AWIN_TOKEN,
    'Content-Type':  'application/json',
  };
}

/* ══════════════════════════════════════════════════════════
   1. PROGRAMMES APPROUVÉS
══════════════════════════════════════════════════════════ */
export async function getApprovedPrograms() {
  // v1.12.606 — Skip sur web (CORS api.awin.com bloque). Sur mobile natif OK.
  if (IS_WEB) return [];
  try {
    var res = await fetch(
      AWIN_BASE + '/publishers/' + AWIN_PUB + '/programmes?relationship=joined&status=approved',
      { headers: authHeaders() }
    );
    if (!res.ok) return [];
    var data = await res.json();
    return Array.isArray(data) ? data : (data.programmes || []);
  } catch (e) {
    console.warn('AWIN getApprovedPrograms:', e.message);
    return [];
  }
}

/* ══════════════════════════════════════════════════════════
   2. CONSTRUIRE UN LIEN AFFILIÉ AWIN
══════════════════════════════════════════════════════════ */
export function buildAwinLink(productUrl, advertiserId, clickRef) {
  if (!productUrl || !advertiserId) return productUrl;
  return 'https://www.awin1.com/cread.php?awinaffid=' + AWIN_PUB
    + '&awinmid=' + advertiserId
    + (clickRef ? '&clickref=' + encodeURIComponent(clickRef) : '')
    + '&ued=' + encodeURIComponent(productUrl);
}

/* ══════════════════════════════════════════════════════════
   3. PRODUITS PAR ADVERTISER (feed produits)
   Limite à 50 articles compatibles avec la garde-robe
══════════════════════════════════════════════════════════ */
export async function getProductsByAdvertiser(advertiserId, options) {
  // v1.12.606 — Skip sur web (CORS api.awin.com bloque). Sur mobile natif OK.
  if (IS_WEB) return [];
  options = options || {};
  var limit = Math.min(options.limit || 50, 50);

  try {
    var url = AWIN_BASE + '/publishers/' + AWIN_PUB + '/products'
      + '?advertiserId=' + advertiserId
      + '&format=json'
      + '&limit=' + limit
      + (options.category ? '&category=' + encodeURIComponent(options.category) : '')
      + (options.keyword  ? '&keyword='  + encodeURIComponent(options.keyword)  : '');

    var res = await fetch(url, { headers: authHeaders() });
    if (!res.ok) {
      console.warn('AWIN products HTTP ' + res.status);
      return [];
    }
    var data = await res.json();
    var products = Array.isArray(data) ? data : (data.products || data.items || []);
    return products.map(normalizeAwinProduct).filter(function(p) { return p && p.price > 0; });
  } catch (e) {
    console.warn('AWIN getProductsByAdvertiser:', e.message);
    return [];
  }
}

/* ══════════════════════════════════════════════════════════
   4. RECHERCHE PRODUITS — 50 articles max compatibles garde-robe
   Filtre par catégories manquantes dans la garde-robe
══════════════════════════════════════════════════════════ */
export async function searchProducts(keyword, options) {
  options = options || {};
  var limit = Math.min(options.limit || 50, 50);

  try {
    var url = AWIN_BASE + '/publishers/' + AWIN_PUB + '/products'
      + '?keyword=' + encodeURIComponent(keyword || 'fashion')
      + '&format=json'
      + '&limit=' + limit
      + (options.category ? '&category=' + encodeURIComponent(options.category) : '');

    var res = await fetch(url, { headers: authHeaders() });
    if (!res.ok) return [];
    var data = await res.json();
    var items = Array.isArray(data) ? data : (data.products || data.items || []);
    return items.map(normalizeAwinProduct).filter(function(p) { return p && p.price > 0; });
  } catch (e) {
    console.warn('AWIN searchProducts:', e.message);
    return [];
  }
}

/* ══════════════════════════════════════════════════════════
   5. TRANSACTIONS (commissions)
══════════════════════════════════════════════════════════ */
export async function getTransactions(dateFrom, dateTo) {
  try {
    var url = AWIN_BASE + '/publishers/' + AWIN_PUB + '/transactions/'
      + '?startDate=' + encodeURIComponent(dateFrom)
      + '&endDate='   + encodeURIComponent(dateTo)
      + '&status=approved';

    var res = await fetch(url, { headers: authHeaders() });
    if (!res.ok) return [];
    var data = await res.json();
    return Array.isArray(data) ? data : (data.transactions || []);
  } catch (e) {
    console.warn('AWIN getTransactions:', e.message);
    return [];
  }
}

/* ══════════════════════════════════════════════════════════
   NORMALISATION — Format AWIN → Format Outfit
══════════════════════════════════════════════════════════ */
function normalizeAwinProduct(p) {
  if (!p) return null;

  var price = parseFloat(
    p.displayPrice || p.searchPrice || p.price || 0
  );
  var name  = p.productName || p.name || '';
  var brand = p.brandName   || p.merchant || '';
  var cat   = mapCategory(p.primaryCategory || p.category || name);

  return {
    id:            'awin_' + (p.productId || p.id || Math.random().toString(36).slice(2)),
    awinId:        p.productId || p.id,
    partner:       'awin',
    source:        'awin',
    name:          name,
    brand:         brand,
    category:      cat,
    price:         price,
    originalPrice: parseFloat(p.rrp || price),
    discount:      null,
    color:         '',
    colors:        [],
    sizes:         [],
    emoji:         getCatEmoji(cat),
    image:         p.imageUrl || p.image || null,
    images:        p.imageUrl ? [p.imageUrl] : [],
    available:     p.inStock !== false,
    rating:        4.0,
    reviews:       0,
    description:   p.description || '',
    gender:        null,
    deliveryDays:  '3–5 j',
    originalUrl:   p.merchantProductUrl || p.url || null,
    affiliateUrl:  p.awDeepLink || buildAwinLink(p.merchantProductUrl, p.advertiserId),
    isRealProduct: true,
    matchScore:    0,
    matchHints:    [],
  };
}

function mapCategory(raw) {
  raw = raw || '';
  var r = raw.toLowerCase();
  if (r.includes('dress') || r.includes('robe'))   return 'Robes';
  if (r.includes('top')   || r.includes('shirt') || r.includes('haut')) return 'Hauts';
  if (r.includes('jacket')|| r.includes('coat')  || r.includes('veste')) return 'Vestes';
  if (r.includes('trouser')|| r.includes('jean') || r.includes('skirt')) return 'Bas';
  if (r.includes('shoe')  || r.includes('boot')  || r.includes('sneaker')) return 'Chaussures';
  if (r.includes('bag')   || r.includes('sac'))   return 'Sacs';
  return 'Accessoires';
}

function getCatEmoji(cat) {
  var m = { Robes:'👗', Hauts:'👚', Vestes:'🧥', Bas:'👖', Chaussures:'👟', Sacs:'👜', Accessoires:'✨' };
  return m[cat] || '👗';
}
